import { Helper } from '../Helper';
export class PutCommonStorageHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.commonStorage);
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'SETITEM');
    }
}

//# sourceMappingURL=PutCommonStorageHelper.js.map
